module.exports = __webpack_public_path__ + "img/martin-wimberger.dd7afaea.jpg";